import {Pipe, PipeTransform} from "@angular/core";

/**
 * Pipe to format a distance number to include distance unit. The number is assumed to be in kilometres.
 */
@Pipe({name: "distance"})
export class DistancePipe implements PipeTransform{

    transform(value: number): string {
        if(!value || value == 0){
            return " ";
        }

        if(value <= 1.0){
            return Math.round(value * 1000) + " m";
        }

        return value + " km";
    }
}
